import styled from 'styled-components';
import { palette } from 'styled-tools';

export const BrandingWrapper = styled.div<{
	alignment?: 'left' | 'center';
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	width: 100%;
	margin: auto;
	margin-bottom: 36px;
	text-align: ${p => (p.alignment === 'left' ? p.alignment : 'center')};

	img {
		max-height: ${p => (p.alignment === 'left' ? '40px' : '50px')};
	}
`;

export const ImageContainer = styled.div`
	height: 50px;
	width: 129px;
	position: relative;
	flex-shrink: 0;
`;

export const CoBrandedGroup = styled.div`
	display: flex;
	min-width: 0;
	align-items: center;
	gap: 10px;
`;

export const LogoDivider = styled.div`
	width: 1px;
	height: 50px;
	background-color: ${palette('gray7')};
	opacity: 0.3;
`;
